(function () {
  'use strict';

  function showNotice(message) {
    var notice = document.getElementById('CartNotification');
    if (!notice) return;
    notice.textContent = message;
    notice.hidden = false;
    clearTimeout(notice._timeout);
    notice._timeout = setTimeout(function () { notice.hidden = true; }, 2600);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = count;
    });
  }

  document.addEventListener('click', function (event) {
    var menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      var nav = document.getElementById('MainNavigation');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      return;
    }

    var filter = event.target.closest('[data-product-filter]');
    if (filter) {
      var value = filter.dataset.productFilter;
      var section = filter.closest('[data-filter-section]');
      if (!section) return;
      section.querySelectorAll('[data-product-filter]').forEach(function (button) {
        var selected = button === filter;
        button.classList.toggle('selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      section.querySelectorAll('[data-product-world]').forEach(function (card) {
        card.hidden = value !== 'all' && card.dataset.productWorld !== value;
      });
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item.');
          return data;
        });
      })
      .then(function (item) {
        showNotice(item.product_title + ' added to your bag');
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); });
      })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function (error) { showNotice(error.message); })
      .finally(function () { if (button) button.disabled = false; });
  });

  document.addEventListener('change', function (event) {
    var selector = event.target.closest('[data-variant-select]');
    if (!selector) return;
    var option = selector.options[selector.selectedIndex];
    var product = selector.closest('[data-product-section]');
    if (!product) return;
    var price = product.querySelector('[data-product-price]');
    var button = product.querySelector('[data-add-to-cart]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableText : button.dataset.soldOutText;
    }
  });
})();
